import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityService } from './security.service';
import { GroupGuard } from './group.guard';

@Injectable()
export class UserManagementGuard extends GroupGuard {

  constructor(private secSvc: SecurityService, router: Router) {
    super(secSvc, router);
    this.validate = () => this.secSvc.isUserManagementAdmin();
  }

}
